import { Button } from 'antd';
import { Plus, ShieldAlert } from 'lucide-react';
import { Navigate, useNavigate } from 'react-router';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { PageHeader } from '../../../../../shared/components/PageHeader';
import { TableSkeleton } from '../../../../../shared/components/TableSkeleton';
import { sectionTrail } from '../../../../../shared/components/section-trail';
import { JobsTable } from '../components/JobsTable';
import { useJobsPage } from '../hooks/use-jobs-page';

/** The jobs list (gitaumoses4/chukua#39): server-side paging, search, filters and sorting, all in the URL. */
export function JobsPage() {
  const { jobs, columns } = useJobsPage();
  const navigate = useNavigate();

  if (jobs.state.status === 'forbidden') return <Navigate to="/" replace />;

  return (
    <>
      <PageHeader
        breadcrumbs={sectionTrail('jobs')}
        title="Jobs"
        description="Every job from enquiry to delivery. Open one to see its cargo, terms, attachments and state."
        actions={
          <Button type="primary" icon={<Plus className="size-4" />} onClick={() => navigate('/jobs/new')}>
            Create job
          </Button>
        }
      />
      {jobs.state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load jobs" description="Something went wrong loading the jobs list. Try reloading the page." />
      )}
      {jobs.state.status === 'loading' && <TableSkeleton label="Loading jobs" withSearch />}
      {jobs.state.status === 'loaded' && <JobsTable page={jobs.state.page} columns={columns} list={jobs.list} isRefreshing={jobs.isRefreshing} />}
    </>
  );
}
